import * as angular from "angular";
import {IController, IScope} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";

export class OmsOrdersTableRowController implements IController {

  columns: any;
  dynamicColumns: any;
  packageDynamicColumns: any;
  orderId: string;
  isSelected: boolean;
  isExpended: boolean;
  isAllowSelect: boolean;
  isAllowActions: boolean;
  onToggleSelect: Function;
  onToggleExpand: Function;
  onSendToDispatch: Function;
  onFilterByType: Function;

  public itemsIds: string[] = [];
  public itemsTypes: string[] = [];
  public itemsBarcodes: string[] = [];
  public sitePackageItemsMap: any;
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;

  constructor(private $omsOrder, private $scope: IScope, private splitService: SplitService) {
  }

  $onInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    if (this.orderId) {
      this.$omsOrder(this.orderId).$bindCtrlToId(this.$scope, this, 'order', 'orderId');
    }
  }

  $onChanges(changes) {
    if (changes.orderId && !changes.orderId.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrdersTableRow', {
    bindings: {
      columns: '<',
      dynamicColumns: '<?',
      packageDynamicColumns: '<?',
      orderId: '<',
      isSelected: '<',
      isExpended: '<',
      isAllowSelect: '<?',
      isAllowActions: '<?',
      onToggleSelect: '&',
      onToggleExpand: '&',
      onAssign: '&',
      onSendToDispatch: '&',
      onFilterByType: '&'
    },
    template: require('./oms-orders-table-row.html').default,
    controller: OmsOrdersTableRowController
  });
